import { useMemo, useState } from 'react';
import { numeric } from 'shared-base';
import { formDefaults, forms } from '../../_definitions/forms';
import Form from '../Form/Form';
import { Estimate, Wrapper } from './FormOrder.style';
import { calculateCost } from './FormOrder.utils';

export type FormOrderProps = {
  email: string;
  onCta: (value: Json) => void;
  onCancel: () => void;
};

export function FormOrder(props: FormOrderProps) {
  const { email } = props;

  const [value, setValue] = useState<Json>({
    complexity: 'Simple',
    exclusivity: 'Non-Exclusive',
  });

  function onChange(_change: Json, allData: Json) {
    setValue(allData);
  }

  const cost = useMemo(() => {
    return calculateCost(value);
  }, [value]);

  return (
    <Wrapper className='FormOrder-wrapper' data-testid='FormOrder-wrapper'>
      <Form
        config={forms.order as any}
        allOptions={{}}
        data={{ ...formDefaults.order, email }}
        onChange={onChange}
        onCancel={props.onCancel}
      >
        {cost.isValid && (
          <Estimate>
            <strong>Estimated cost:</strong> ${numeric(cost.min)}-${numeric(cost.max)}
          </Estimate>
        )}
      </Form>
    </Wrapper>
  );
}

export default FormOrder;
